export default __webpack_public_path__ + "static/media/campur.8aa44f48.png";